export default "__VITE_ASSET__8J0XnowI__"